import { useParams } from "react-router";
import Collaboration from "../../components/collaboration/Collaboration";

const CollaborationPage = () => {
  const { id } = useParams();

  return <Collaboration selectedSpaceIdFromUrl={id ? Number(id) : undefined} />;
};
export default CollaborationPage;
